import { AuthenticatedGuard } from "@/components/authenticated-guard";
import Header from "@/components/header.tsx";
import { InspectionThemeProvider } from "@/components/inspection/inspection-theme-context";
import { InspectionOperatorImpersonationGate } from "@/components/inspection/operator-impersonation-gate";
import { UserType } from "@/constants";
import { getInspectionLoginConnection } from "@/lib/inspection-login-connection";
import { trySilentInspectionAuth } from "@/lib/inspection-sso";
import { useAuth0 } from "@auth0/auth0-react";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import Auth0Provider from "../integrations/auth0/root-provider.tsx";

function InspectionLayout() {
  const { user, getAccessTokenSilently } = useAuth0();
  const trySilentAuth = useCallback(
    () => trySilentInspectionAuth(getAccessTokenSilently),
    [getAccessTokenSilently],
  );

  return (
    <div className="inspection-portal flex h-dvh flex-col overflow-hidden">
      <InspectionThemeProvider>
        <Header
          user={user || null}
          showInspectionOperatorImpersonation
          showInspectionHelp
        />
        <main className="mx-auto flex w-full max-w-[1600px] flex-1 min-h-0 justify-center overflow-hidden bg-white p-4 text-black md:p-6">
          <AuthenticatedGuard
            allowedUserTypes={[UserType.REGISTRANT, UserType.OPERATOR]}
            loginConnection={getInspectionLoginConnection()}
            trySilentAuth={trySilentAuth}
          >
            <InspectionOperatorImpersonationGate>
              <div
                data-slot="portal-page-scroll"
                className="flex flex-1 min-h-0 w-full min-w-0 flex-col overflow-y-auto"
              >
                <Outlet />
              </div>
            </InspectionOperatorImpersonationGate>
          </AuthenticatedGuard>
        </main>
      </InspectionThemeProvider>
    </div>
  );
}

export const Route = createFileRoute("/inspection")({
  component: () => (
    <Auth0Provider
      audience={import.meta.env.VITE_AUTH0_INSPECTION_AUDIENCE}
      clientId={import.meta.env.VITE_AUTH0_INSPECTION_CLIENT_ID}
      callbackPath="/inspection/auth_callback"
    >
      <InspectionLayout />
    </Auth0Provider>
  ),
});
